module.exports = __webpack_public_path__ + "static/media/sgd-6.16260c39.png";